import { createSlice, Slice } from '@reduxjs/toolkit'

import { CurrentUser } from 'typings/currentUser'

export interface UserState extends Partial<CurrentUser> {
  loaded: boolean
  isFetching: boolean
}

const initialState: UserState = {
  loaded: false,
  isFetching: false
}

export const userSlice: Slice<UserState> = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setUser: (state, { payload }) => ({ ...state, ...payload, loaded: true, isFetching: false })
  }
})

const { reducer: UserReducer, actions } = userSlice

export const { setUser } = actions

export default UserReducer
